/**
 * Convert the fractional odds into decimal.
 * @param {number[]} fractionalOdds
 * @returns {number}
 */
function convertToDecimal(fractionalOdds: number[]): number {
  return fractionalOdds[0] / fractionalOdds[1] + 1;
}

/**
 * Outputs the total return value for the given set of odds in the uk format.
 * @param {number[][]} fractionalOddsList
 * @returns {number}
 */
export function calcParlayAccumulator(fractionalOddsList: number[][]): number {
  const decimalOdds = fractionalOddsList.map(fractionalOdds =>
    convertToDecimal(fractionalOdds)
  );
  return decimalOdds.reduce((product, decimalOdd) => product * decimalOdd, 1);
}
